var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('Section',{attrs:{"disable-margin-top":_vm.disableMarginTop,"disable-margin-bottom":_vm.disableMarginBottom}},[(_vm.pending)?_c('EmptyHeroSlider'):_c('HeroSlider')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }